import { render } from "./PracticePlanView.vue?vue&type=template&id=6f87c415&scoped=true"
import script from "./PracticePlanView.vue?vue&type=script&lang=js"
export * from "./PracticePlanView.vue?vue&type=script&lang=js"

import "./PracticePlanView.vue?vue&type=style&index=0&id=6f87c415&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f87c415"]])

export default __exports__